export default "__VITE_ASSET__BuhRwXlJ__"